import { render, staticRenderFns } from "./MoblieLikeMessage.vue?vue&type=template&id=281bc866&scoped=true&"
import script from "./MoblieLikeMessage.vue?vue&type=script&lang=js&"
export * from "./MoblieLikeMessage.vue?vue&type=script&lang=js&"
import style0 from "./MoblieLikeMessage.vue?vue&type=style&index=0&id=281bc866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281bc866",
  null
  
)

export default component.exports